import type { ComponentProps } from "react";
import { LuArrowUpDown } from "react-icons/lu";

import {
  hasSwappablePreviewOrGatedContent,
  swapPreviewAndGatedContent,
} from "@/components/app/editor-v3/editor-gated-content-utils";
import { InfoTooltip } from "@/components/shared/info-tooltip";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils/lib";

import { useEditorContext } from "../editor-context";

export const EditorActionSwapGatedContent = ({
  className,
  ...props
}: ComponentProps<typeof Button>) => {
  const editorContext = useEditorContext();
  const canSwap = hasSwappablePreviewOrGatedContent(editorContext);

  return (
    <InfoTooltip
      className="hidden md:block"
      mobile={false}
      text="Swap preview and gated content"
    >
      <Button
        aria-label="Swap preview and gated content"
        className={cn("rounded-full text-muted", className)}
        disabled={!canSwap}
        onClick={() => {
          editorContext.setEditorContext(
            swapPreviewAndGatedContent(editorContext),
          );
        }}
        size="icon"
        variant="outline"
        {...props}
      >
        <LuArrowUpDown className="text-base" />
      </Button>
    </InfoTooltip>
  );
};
